export var LandingPageInitProps = {
    gameId: 38,
    networkGroupId: 1,
    networkId: 1,
    parentFilter: "bigfarm.com",
    trackingInstanceId: 1,
    trustedDomains: [
        "https://bigfarm-html5.goodgamestudios.com",
        "https://bigfarm-html5-test.goodgamestudios.com",
        "https://empiremillenniumwars.ggs-emw.com",
        "https://provider.goodgamestudios.com",
        "https://provider-test.goodgamestudios.com",
        "https://empire-html5.goodgamestudios.com",
        "https://empire-html5-test.goodgamestudios.com",
        "https://gamestaging.empiremillenniumwars.com",
        "https://game.empiremillenniumwars.com",
        "https://gi.goodgamestudios.com",
        "https://gi-test.goodgamestudios.com",
        "https://media.goodgamestudios.com",
        "https://gamestaging.bigfarm.com",
        "http://bigfarm.com",
        "https://bigfarm.com",
        "http://localhost:3000",
        "http://localhost:3001",
        "http://localhost:63342",
    ],
};



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/LandingPageInitProps.ts
// module id = 1701
// module chunks = 3